import styles from './styles.module.css';

const VideoLive = (props) => {
    
    const {
        title,
        text,
        url,
        isPreview,
        clase
    } = props;
    
    let urlIframe;
    if (url.indexOf('youtube') != -1) {
        let regexYoutube = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|(?:v|l(?:ive)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;
        const idVideo = regexYoutube.exec(url)
        urlIframe =  `https://www.youtube.com/embed/${idVideo[1]}?autoplay=1&mute=1`;
    } 
    if (url.indexOf('facebook') != -1) {
        urlIframe = "https://www.facebook.com/plugins/video.php?height=314&href=" + encodeURI(url) + "&show_text=false&t=0";
    }
    if (url.indexOf('livestream.com') != -1) {
        urlIframe = url;
     }
     if (url.indexOf('jwplayer') != -1) {
        urlIframe = url;
     }
     if (url.indexOf('habilitado-ellitoral') != -1) {
        urlIframe = url;
     }

    return (
      <div className='Principal'>  
      {clase === "Grande" && (
        <div className={isPreview ? styles['preview-containter'] : styles['container-video']}> 
            <div className={styles['center']}>
                <p>{text}</p>
            </div>
            <div className={styles['embebed-video']}>
                <iframe 
                    src={urlIframe}
                    width="100%"
                    scrolling="no" 
                    frameBorder="0" 
                    allowFullScreen={true}
                    loading="lazy"
                    allow="autoplay; clipboard-write; encrypted-media ; picture-in-picture; web-share;"
                    title={title}
                />
            </div>            
            <div className={styles['center']}>
                <h2>{title}</h2>
            </div>
        </div>
          
      )
    }

        {clase === "Peque" && (
        <div className={isPreview ? styles['preview-containter-peque'] : styles['container-video-peque']}> 
               <div className={styles['livepeque']}>
            <p>{text}</p>
            <div className={styles['centerpeque']}>
              <h2>{title}</h2>
            </div>
          </div>

          <div className={styles['embebed-video-peque']}>
            <iframe
              src={urlIframe}
              scrolling="no"
              frameBorder="0"
              allowFullScreen
              loading="lazy"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture;"
              title={title}
            />
          </div> 
        </div>
          
      )
    }

    </div>
    
  )
}
export default VideoLive;
